import "react-image-lightbox/style.css";
import "./src/css/style.css";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
